import { getUserLocale } from "@/services/locale";
import axios from "axios";

const clientApi = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
});

clientApi.interceptors.request.use(async (config) => {
  const locale = await getUserLocale();

  config.headers["Accept-Language"] = locale;
  return config;
});

export default clientApi;
